











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Level extends Vue {
  @Prop() level!: number;
  @Prop({default: 5}) levelMax!: number;

}
